// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const list = "List__list__o4E6C";
export const listItem = "List__listItem__NOKRR";
export const orderedList = "List__orderedList__nTkIj";
export const unorderedList = "List__unorderedList__eMUTr";
export const bulletBold = "List__bulletBold__REWOW";
export const tableOfContents = "List__tableOfContents__xK7wo";